module.exports = __webpack_public_path__ + "img/file-pen-sharp-light.28a4fe7f.svg";